import { X } from "lucide-react";
import { createPortal } from "react-dom";
import ProfileImage from "./ProfileImage";

const modalRoot = typeof window !== "undefined" ? document.getElementById("modal-root") : null;

export function UserViewModal({ onClose, user }) {
    if (!modalRoot) return null;

    return createPortal(
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4 sm:px-6">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-5xl max-h-[90vh] overflow-y-auto p-6 relative">
                {/* Close button */}
                <button
                    className="absolute top-4 right-4 text-gray-500 hover:text-red-500"
                    onClick={onClose}
                >
                    <X size={20} />
                </button>

                <h2 className="text-2xl font-semibold mb-6">User Details</h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    {/* Profile Image */}
                    <div>
                        <span className="text-sm font-medium text-gray-500">Profile Image</span>
                        <div className="mt-2">
                            <ProfileImage imageUrl={user?.image} className="!w-16 !h-16" />
                        </div>
                    </div>

                    <div className={`${Object.entries(user?.urlParams || {}).length > 4 ? 'md:row-span-4' : 'md:col-start-2'}`}>
                        <span className="text-sm font-medium text-gray-500">URL Params:</span>
                        {user?.urlParams && typeof user.urlParams === "object" ? (
                            <ul className="mt-2 pl-4 list-disc text-sm text-gray-700 max-h-40 overflow-y-auto pr-2">
                                {Object.entries(user.urlParams).map(([key, value]) => (
                                    <li key={key}>
                                        <strong>{key}:</strong> {value}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-base mt-2">-</p>
                        )}
                    </div>

                    {/* User ID */}
                    <Field label="User ID" value={user?._id} />


                    {/* Name */}
                    <Field label="Name" value={user?.name} />

                    {/* First Name */}
                    <Field label="First Name" value={user?.firstName} />

                    {/* Last Name */}
                    <Field label="Last Name" value={user?.lastName} />

                    {/* Nick Name */}
                    <Field label="Nick Name" value={user?.nickName} />

                    {/* Email */}
                    <Field label="Email" value={user?.email} />

                    {/* Phone */}
                    <Field label="Phone" value={user?.session?.phone} />

                    {/* Bio */}
                    <Field label="Bio" value={user?.session?.bio} />

                    {/* Dream Credits */}
                    <Field label="Dream Credits" value={user?.session?.dreamCredits} />

                    {/* Credits */}
                    <Field label="Credits" value={user?.credit} />

                    {/* Customer ID */}
                    <Field label="Customer ID" value={user?.session?.customerId} />

                    {/* Following / Followers */}
                    <Field
                        label="Following / Followers"
                        value={`${user?.session?.followingCount || 0} / ${user?.session?.followerCount || 0}`}
                    />

                    {/* Default Follower */}
                    <Field
                        label="Default Follower Added"
                        value={user?.session?.isDefaultFollowerAdded ? "Yes" : "No"}
                    />

                    {/* Email Verified */}
                    <Field
                        label="Email Verified"
                        value={user?.emailVerified ? new Date(user.emailVerified).toLocaleString() : "N/A"}
                    />

                    {/* Created At */}
                    <Field
                        label="Created At"
                        value={user?.createdAt ? new Date(user.createdAt).toLocaleString() : "N/A"}
                    />

                    {/* URL Params
                    {user?.urlParams && typeof user.urlParams === "object" && (
                        <div className="md:col-span-2">
                            <span className="text-sm font-medium text-gray-500">URL Params:</span>
                            <ul className="mt-2 pl-4 list-disc text-sm text-gray-700">
                                {Object.entries(user.urlParams).map(([key, value]) => (
                                    <li key={key}>
                                        <strong>{key}:</strong> {value}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )} */}
                </div>
            </div>
        </div>,
        modalRoot
    );
}

function Field({ label, value, className = '' }) {
    return (
        <div className={className}>
            <span className="text-sm font-medium text-gray-500">{label}:</span>
            <p className="text-base break-words">{value || "N/A"}</p>
        </div>
    );
}
